import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { basicLayoutActions } from "./actions";
import { BasicLayoutService } from "../services/basic-layout.service";

@Injectable()
export class BasicLayoutEffects {

  postSubscribe$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(basicLayoutActions.sendSubscribe),
      switchMap(({ email }) =>
        this.service.sendSubscribe(email).pipe(
          map(() => basicLayoutActions.subscribeSuccess()),
          catchError((error) => {
            return of(basicLayoutActions.subscribeFailure({ error }));
          })
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private service: BasicLayoutService,
  ) {}
}
